import Rest from "../../../class/tool/Rest";
import News from "./News";

class NewsController {
	_rest = new Rest();
	_callback = null;
	_baseURL = "news";

	// Controllers

	index() {
		this._rest.sendQuery(
			'GET',
			'/' + this._baseURL,
			{},
			this.handleIndex)
	}
	handleIndex = (response, error, status) => {
		let listObjects = []
		let pagination = null

		if(status === 200) {
			let data

			if (response.data !== undefined && response.data.data !== undefined) {
				if(response.data.total !== undefined) {
					pagination = {
						total: response.data.total,
						from: response.data.from != null ? response.data.from : 0,
						to: response.data.to != null ? response.data.to : 0,
						per_page: response.data.per_page,
						current_page: response.data.current_page,
						first_page_url: new URL(response.data.first_page_url).search,
						last_page_url: new URL(response.data.last_page_url).search,
						next_page_url: response.data.next_page_url !== null ? new URL(response.data.next_page_url).search : null,
						prev_page_url: response.data.prev_page_url !== null ? new URL(response.data.prev_page_url).search : null
					}
				}

				data = response.data.data
			}
			else if (response.data)
				data = response.data

			for(let item in data)
				listObjects.push(new News(data[item]))
		}

		this._callback(listObjects, error, pagination, status)
	}

	post(datas) {
		this._rest.sendQuery(
			'POST',
			'/' + this._baseURL,
			datas,
			this.handlePost
		)
	}
	handlePost = (response, error, status) => {
		if (this._callback !== null) {
			this._callback(response, error, status)
		}
	}

	put(object, datas) {
		this._rest.sendQuery(
			'PUT',
			'/' + this._baseURL + '/' + object.id,
			datas,
			this.handlePut
		)
	}
	handlePut = (response, error, status) => {
		this._callback(response, error, status)
	}

	delete(object) {
		this._rest.sendQuery(
			'DELETE',
			'/' + this._baseURL + '/' + object.id,
			{},
			this.handleDelete)
	}
	handleDelete = (response, error, status) => {
		this._callback(response, error, status)
	}
}

export default NewsController;